// pageActivity — is the page busy, or holding typed input? T506 (2026-10-06), v0.1.
//
// Imported FIRST in src/main.tsx, before anything that creates the Supabase client: the
// client captures `fetch` when it is created, so the wrapper has to be in place before that
// or a save or send through it would never be counted.
//
// Typed input: React keeps a field's value attribute in step with its state, so comparing
// value with defaultValue cannot tell; the input event can. VersionWatcher clears it on a
// route change (leaving a page).

let dirty = false;
let inFlight = 0;

if (typeof window !== "undefined" && typeof document !== "undefined") {
  document.addEventListener("input", (e: Event) => {
    const t = e.target as HTMLElement | null;
    if (!t) return;
    if (t instanceof HTMLInputElement || t instanceof HTMLTextAreaElement || t instanceof HTMLSelectElement || t.isContentEditable) dirty = true;
  }, true);
  const orig = window.fetch.bind(window);
  window.fetch = (async (...args: Parameters<typeof fetch>) => {
    const [input, init] = args;
    const method = String(init?.method || (input instanceof Request ? input.method : "GET")).toUpperCase();
    const counts = method !== "GET" && method !== "HEAD";
    if (counts) inFlight++;
    try { return await orig(...args); }
    finally { if (counts) inFlight = Math.max(0, inFlight - 1); }
  }) as typeof window.fetch;
}

/** Some field on the page has been typed into since the last route change. */
export function pageIsDirty(): boolean { return dirty; }
/** A non-GET request (a save or a send) is still in flight. */
export function pageIsBusy(): boolean { return inFlight > 0; }
/** A route change: the page with the typed input was left. */
export function clearPageDirty(): void { dirty = false; }
